import { Sun, Moon, Monitor } from "lucide-react";
import { useTheme } from "@/contexts/ThemeContext";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface ThemeToggleProps {
  showTooltip?: boolean;
}

export function ThemeToggle({ showTooltip }: ThemeToggleProps) {
  const { mode, setMode, resolvedTheme } = useTheme();

  const icon = mode === "system" ? <Monitor className="h-4 w-4" /> :
    resolvedTheme === "dark" ? <Moon className="h-4 w-4" /> : <Sun className="h-4 w-4" />;

  return (
    <DropdownMenu>
      <Tooltip>
        <TooltipTrigger asChild>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="icon" className="h-9 w-9">
              {icon}
              <span className="sr-only">Alternar tema</span>
            </Button>
          </DropdownMenuTrigger>
        </TooltipTrigger>
        {showTooltip ? <TooltipContent side="right">Alternar tema</TooltipContent> : null}
      </Tooltip>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => setMode("light")} className="gap-2">
          <Sun className="h-4 w-4" /> Claro
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setMode("dark")} className="gap-2">
          <Moon className="h-4 w-4" /> Escuro
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setMode("system")} className="gap-2">
          <Monitor className="h-4 w-4" /> Sistema
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
